import React, { ChangeEvent } from 'react';
import { Search } from 'lucide-react';

interface Category {
  id: string;
  label: string;
}

interface FilterBarProps {
  search: string;
  onSearch: (e: ChangeEvent<HTMLInputElement>) => void;
  searchPlaceholder: string;
  activeCategory: string;
  onCategoryChange: (id: string) => void;
  categories: Category[];
  allLabel: string;
}

const PILL = 'px-3 py-1.5 md:px-4 md:py-2 rounded-full text-xs md:text-sm font-semibold font-syne transition-all duration-200';
const ACTIVE = 'bg-teal text-navy';
const INACTIVE = 'bg-white text-text-mid border border-black/[0.08] hover:border-teal';

export default function FilterBar({
  search, onSearch, searchPlaceholder,
  activeCategory, onCategoryChange,
  categories, allLabel,
}: FilterBarProps) {
  return (
    <div className="flex flex-col gap-3 mb-6 md:mb-8">
      {}
      <div className="relative w-full">
        <Search size={16} className="absolute left-4 top-1/2 -translate-y-1/2 text-text-light" />
        <input
          type="text"
          placeholder={searchPlaceholder}
          value={search}
          onChange={onSearch}
          className="w-full pl-10 pr-4 py-3 bg-white border border-black/[0.08] rounded-md text-sm text-navy
                     outline-none focus:border-teal focus:shadow-[0_0_0_3px_rgba(0,180,160,0.12)] transition-all"
        />
      </div>

      {}
      <div className="flex flex-wrap gap-2">
        <button
          onClick={() => onCategoryChange('all')}
          className={`${PILL} ${activeCategory === 'all' ? ACTIVE : INACTIVE}`}
        >
          {allLabel}
        </button>
        {categories.map(cat => (
          <button
            key={cat.id}
            onClick={() => onCategoryChange(cat.id)}
            className={`${PILL} ${activeCategory === cat.id ? ACTIVE : INACTIVE}`}
          >
            {cat.label}
          </button>
        ))}
      </div>
    </div>
  );
}
